import ServerRequest from './ServerRequest';

const moment = require('moment');
const { getExchangeName } = require('./MessageStructure');


export const StockPrice = async (exchange, token) => {

    return new Promise(async (resolve, reject) => {

        const start_time = moment().subtract(1, 'weeks').unix();
        const end_time = moment().unix();
        exchange = getExchangeName(exchange).exchange;

        const response = await ServerRequest({
            method: "GET",
            url: `/GetStockPriceHistory?exchange=${exchange}&token=${token}&candletype=3&starttime=${start_time}&endtime=${end_time}&data_duration=1`,
            data: {
                portfolioName: "",
            },
        });

        const data = response;

        if(data?.error){
            resolve({
                error: true,
            })
        }
        else{
            const close_array = data?.close_array || [];
            resolve({
                error: false,
                closearray: close_array.reverse(),
            })
        }
    })
}
